import { buildPermissionUser, type PermissionUser } from "@/D2C/features/auth/utils/permissions";
import { App_Url_New } from "@/shared/common/static";
import FloatingButtons from "@/shared/components/FloatingButtos";
import { axiosInstance } from "@/shared/lib/axiosInstance";
import { logout, userData } from "@/shared/redux/reducers/authSlice";
import { usePosterReducers } from "@/shared/redux/store/useGetData";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import AuthHeader from "./AuthHeader";
import AuthSidebar from "./AuthSidebar";

export default function AuthLayout() {
  const {
    auth: { user },
  } = usePosterReducers();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log("USERDATA", user);

  useEffect(() => {
    if (user) {
      axiosInstance
        .get(App_Url_New.ApiEndPoint.userData)
        .then((response) => {
          const data = response.data;

          //           if (response.status === 401) {
          //             dispatch(logout());
          //             navigate(App_Url_New.CommonPageUrl.login);
          //             return;
          //           }
          const formattedResponse = {
            ...user,
            user: buildPermissionUser(data as PermissionUser),
          };
          dispatch(userData(formattedResponse));
          console.log("User:", response.data);
        })
        .catch((error) => {
          if (error.status === 401) {
            dispatch(logout());
            setTimeout(() => {
              navigate(App_Url_New.CommonPageUrl.login);
            }, 0);
            navigate(App_Url_New.CommonPageUrl.login);
            return;
          }
          console.error("Error fetching user data:", error);
        });
    }
  }, []);

  return (
    <div className="h-screen flex overflow-hidden">
      <AuthSidebar />

      <main className="flex-1 flex flex-col overflow-hidden">
        <AuthHeader />

        <div className="flex min-h-0 flex-1 flex-col overflow-auto thin-scrollbar bg-theme-surface-soft">
          <div className="mx-auto flex h-full w-full min-h-0 flex-col px-4 py-1.5">
            <Outlet />
          </div>
        </div>
      </main>
      <FloatingButtons />
    </div>
  );
}
